import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';

function normalizeNA(value: unknown): unknown {
  if (value === 'N/A') return null;
  if (value instanceof Date) return value;
  if (Array.isArray(value)) return value.map(normalizeNA);
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, normalizeNA(v)]));
  }
  return value;
}

export const naNormalizerInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    map(response => {
      if (response instanceof HttpResponse && response.body) {
        return response.clone({ body: normalizeNA(response.body) });
      }
      return response;
    })
  );
};
